"use client";

import { createApi } from "@reduxjs/toolkit/query/react";

import baseQuery from "@/libs/shared/api/baseQuery";
import { CheckoutParams, CheckoutResponse } from "./checkout.types";

export const checkoutApi = createApi({
  reducerPath: "checkoutApi",
  baseQuery,
  endpoints: (builder) => ({
    checkPaymentSucceeded: builder.query<CheckoutResponse, CheckoutParams>({
      query: ({ customerId, internalProductId }) => ({
        url: `/connect/customer/check_payment_succeeded`,
        params: {
          customer_id: customerId,
          internal_product_id: internalProductId,
        },
      }),
    }),
  }),
});

export const { useCheckPaymentSucceededQuery } = checkoutApi;
